<template>
  <div class="ds">
    <section class="ds-main">
      <h1 class="ds-heading">Design System</h1>
      <section class="ds-component is-type">
        <h2 class="ds-subheading">Typography</h2>
        <!-- TODO - add selector here for different themes -->
        <h1 class="h1">Heading One</h1>
        <h2 class="h2">Heading Two</h2>
        <h3 class="h3">Heading Three</h3>
        <div class="p-container">
          <p>Fanfolk is a web-based app that gives you a free, white-labeled website with subscriptions built-in. All of this happens instantly when you sign up, you just add your content.</p>
          <p>Fanfolk was started by a group of digital creators who: write, create art, and share what we learn.</p>
          <p>We ran in to this problem: our true fans were asking to pay us for our work. Our thought: let’s add all of our work to a website, and charge a monthly subscription for unlimited access (a similar model to Netflix, MasterClass, and other subscription services).</p>
          <p>We tried to set this up ourselves: building the website, hosting it, and setting up payments. Despite us being professional software designers and engineers, this was difficult. It shouldn’t be.</p>
          <p>We also saw challenges with existing solutions. We didn’t want our content getting lost in a timeline. We didn’t want to flood our fans with emails. We wanted a website with subscriptions.</p>
          <p>That’s why we created Fanfolk.</p>
          <p>Along the way, we found other creators running in to the same roadblocks. People with real-world skills who happened to have a following on Twitter, Instagram, or email. They were looking for a solution, and couldn’t find what they were looking for.</p>
          <p>We are product-first (which is why you haven't heard of us). We focus on creating value for our creators, then do as much as we can to support them. We align ourselves with the goals of our customers: we think it’s better that way.</p>
          <p>If you have any questions, or would like to learn more, please reach out. Fanfolk currently has a waitlist, add yourself to the list here.</p>
        </div>
      </section>
      <section class="ds-component">
        <h2 class="ds-subheading">FFButton</h2>
        <div class="ff-button__container">
          <ff-button :text="'Call to Action'"/>
          <ff-button :text="'Second Action'" :pattern="2" :icon="'share'"/>
          <ff-button :text="'Third'" :pattern="2" :icon="'download'"/>
          <ff-button :icon="'close'" :pattern="2"/>
          <ff-context-menu :items="[{ title: 'Option One'}, { title: 'Option 2'}]" :icon="'ellipsis'"/>
        </div>
        <ff-sidelist
          :heading="'FF Sidelist'"
          :items="[{ title: 'Item One', id: 0}, { title: 'Item Two', id: 1} ]"
          :route="$route.params"
        />
        <ff-button :text="'Item with Icon'" :pattern="2" :icon="'share'"/>
        <ff-button :text="'No icon'" :pattern="2"/>
        <ff-button
          class="sidebar-pages__item"
          :icon="'preview'"
          :text="'Preview Channel'"/>
        <ff-button
          class="sidebar-pages__item"
          :icon="'settings'"
          :text="'Settings'"/>
        <ff-button
          class="sidebar-pages__item is-demure"
          :text="'Profile'"/>
        <ff-button
          class="sidebar-pages__item is-demure"
          :text="'Sign Out'"/>

        <h3 class="ds-desc">Props</h3>
        <ul class="ds-list">
          <li>action</li>
          <li>text</li>
          <li>options</li>
          <li>pattern</li>
          <li>disabled</li>
        </ul>
      </section>
      <section class="ds-component">
        <h2 class="ds-subheading">Actions</h2>
        <ff-context-menu :items="[{ title: 'Option One'}, { title: 'Option 2'}]" :icon="'ellipsis'"/>
        <ff-dropdown/>
      </section>
      <section class="ds-component">
        <h2 class="ds-subheading">Loading</h2>
        <ff-loading/>
      </section>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'


// import Sidebar from '../_Shared/Sidebar'
import FFLoading from '../DesignSystem/FFLoading'
import FFButton from '../DesignSystem/FFButton'
import FFContextMenu from '../DesignSystem/FFContextMenu'
import FFDropdown from '../DesignSystem/FFDropdown'
import FFSidelist from '../DesignSystem/FFSidelist'

export default {
  name: 'Channel',
  components: {
    // Sidebar,
    'ff-loading': FFLoading,
    'ff-button': FFButton,
    'ff-context-menu': FFContextMenu,
    'ff-dropdown': FFDropdown,
    'ff-sidelist': FFSidelist,
  },
  methods: {
  },
  computed: {
    ...mapState(['user', 'channel', 'channel_id'])
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";
  .ds {
    max-width: $maxWidth--wide;
    margin: auto;
  }

  .ds-heading {
    @include h1;
  }

  .ds-subheading {
    @include h2;
  }

  .ff-button__container {
    display: flex;
  }

  .is-type {
    h1 { @include h1 }
    h2 { @include h2 }
    h3 { @include h3 }
  }

  .sidebar-pages__item {
    @include sidebar-item;
  }


  @import "../../assets/styles/mobile.scss";
</style>
